import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Flex, Text } from 'Components/Base';
import Loading from 'Components/Loading';
import { useConfig } from 'Context/ConfigContext';
import { isLoading, isLogin } from 'Redux/user-profile/selectors';
import { useCapacitor } from 'Util/Capacitors';
import { navigateToTungKai } from 'Util/navigateToTungKai';

import LoginSuccessModal from './Components/LoginSuccessModal';

const LoginSuccess = ({ isLogin, isLoading }) => {
  const { t } = useTranslation('registerLogin');
  const config = useConfig();
  const { landingRoute = '/my-courses' } = config;
  const { openInApp } = useCapacitor();
  const history = useHistory();

  useEffect(() => {
    if (!isLoading) {
      if (isLogin) {
        setTimeout(async () => {
          try {
            if (!config?.tungKai?.loginUrl) throw new Error('TungKai loginUrl not configured');
            await navigateToTungKai({ config, openInApp });
          } catch {
            history.replace(landingRoute);
          }
        }, 2000);
        return;
      }

      return history.replace('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  return (
    <Flex
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      py={9}
      fontFamily="'IBM Plex Sans Thai Looped', Anuphan, sans-serif"
    >
      {isLoading && (
        <>
          <Loading width={100} height={100} />
          <Text mt={3}>{t('LOADING')}</Text>
        </>
      )}
      <LoginSuccessModal isOpen={isLogin} />
    </Flex>
  );
};

const mapStateToProps = (state) => ({ isLogin: isLogin(state), isLoading: isLoading(state) });
export default connect(mapStateToProps, {})(LoginSuccess);
